(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        // var defaultProductId = 2; //todo: agree on default product (FPAS or smth. else?)
        vm.account = null;
        vm.isAuthenticated = null;
        vm.hasAnyAuthority = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.hasAnyAuthority = Principal.hasAnyAuthority;
                if (vm.isAuthenticated()) {
                    $state.go('main');
                }
            });
        }


        function register () {
            $state.go('register');
        }

    }
})();
